import http from '../plugins/axios'

export const getAllBrandList = async (params) => {
  try {
    const response = await http.get(`/api/v2/brands`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}

export const addBrand = async (payload) => {
  try {
    const response = await http.post(`/api/v2/brands`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const updateBrand = async (brandId, payload) => {
  try {
    const response = await http.put(`/api/v2/brands/${brandId}`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const deleteDataBrand = async (brandId) => {
  try {
    const response = await http.delete(`/api/v2/brands/${brandId}`)
    return response.data
  } catch(error) {
    throw error
  }
}

export const uploadImage = async (brandId, formData) => {
  try {
    const response = await http.post(`/api/v2/brands/${brandId}/image`, formData)
    return response.data
  } catch(error) {
    throw error
  }
}